import React, { useState, useEffect } from "react";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { getStorage, ref, deleteObject, listAll, getDownloadURL } from "firebase/storage"; // Asegúrate de importar Firebase Storage
import Alerta from '../../../components/Alerta'; // Componente personalizado de alerta

const ListaImagenesMisDiseños = () => {
    const [imagenesMisDiseños, setImagenesMisDiseños] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const storage = getStorage(); // Obtén la instancia de Firebase Storage

    // Obtener las imágenes de Firebase Storage
    useEffect(() => {
        const fetchImages = async () => {
            const listRef = ref(storage, 'fotoslistamisdiseñoscalocho/'); // Ruta a la carpeta en Firebase Storage
            const res = await listAll(listRef); // Obtener todos los archivos de la carpeta

            // Obtener las URLs de las imágenes
            const urls = await Promise.all(
                res.items.map(async (itemRef) => {
                    const url = await getDownloadURL(itemRef); // Obtener la URL de cada imagen
                    return { url, name: itemRef.name }; // Retorna un objeto con URL y nombre
                })
            );
            setImagenesMisDiseños(urls); // Guardar las URLs en el estado
        };

        fetchImages();
    }, []);
        
            // Función para eliminar imágenes
    const handleEliminarImagenesMisDiseños = async (urlImagen) => {
        try {
            // Crear una referencia al objeto de la imagen en Firebase Storage y eliminarlo
            const fileRef = ref(storage, urlImagen);

            await deleteObject(fileRef).then(() => {
                console.log('Imagen eliminada con éxito');
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Imagen eliminada con éxito' });

                // Eliminar la imagen de la lista en el estado
                setImagenesMisDiseños((prevImagenes) => prevImagenes.filter(img => img.url !== urlImagen));
            }).catch((error) => {
                console.error('Error al eliminar la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al eliminar la imagen' });
            });
        } catch (error) {
            console.log(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Hubo un error al eliminar la imagen' });
        }
    }

    return(
        <ImageList sx={{ 
            width: '100%',
            height: '85%',
            gap: { xs: 2, sm: 4 },
            padding: { xs: 1, sm: 2, md: 3 },
        }}
        cols={{ xs: 1, sm: 2, md: 3, lg: 4 }} 
        >
            <ImageListItem key="Subheader" cols={2}>
                <ListSubheader component="div" sx={{
                    fontSize: { xs: '18px', sm: '22px', md: '25px' },
                    textAlign: 'center',
                    padding: { xs: 1, sm: 2 },
                }}>Lista de imágenes de la sección Mis Diseños</ListSubheader>
            </ImageListItem>
            {imagenesMisDiseños.map((imagenesmisdiseños) => (
                <ImageListItem key={imagenesmisdiseños.url}>
                    <img
                        src={imagenesmisdiseños.url}
                        alt={imagenesmisdiseños.name}
                        loading="lazy"
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: '8px',
                        }}
                    />
                    <ImageListItemBar
                        title={imagenesmisdiseños.name}
                        sx={{
                            fontSize: { xs: '12px', sm: '14px', md: '16px' },
                            padding: { xs: 1, sm: 2 },
                        }}
                        actionIcon={
                            <IconButton
                                sx={{ 
                                    color: 'rgba(255, 255, 255, 0.54)',
                                    fontSize: { xs: '16px', sm: '20px', md: '24px' },
                                }}
                                aria-label={`eliminar ${imagenesmisdiseños.name}`}
                                onClick={() => handleEliminarImagenesMisDiseños(imagenesmisdiseños.url)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        }
                    />
                </ImageListItem>
            ))}
            <Alerta
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </ImageList>
    );
}

export default ListaImagenesMisDiseños;